import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DaiHoiCoDongService from "services/crm/DaiHoiCoDongService";

export const SearchDaiHoiCoDong = createAsyncThunk(
  "daiHoiCoDong/SearchDaiHoiCoDong",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DaiHoiCoDongService.searchGrid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDaiHoiCoDongById = createAsyncThunk(
  "daiHoiCoDong/GetDaiHoiCoDongById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DaiHoiCoDongService.getById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const CreateDaiHoiCoDong = createAsyncThunk(
  "daiHoiCoDong/CreateDaiHoiCoDong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await DaiHoiCoDongService.create(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateDaiHoiCoDong = createAsyncThunk(
  "daiHoiCoDong/UpdateDaiHoiCoDong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      console.log(payload, "payload");
      const response = await DaiHoiCoDongService.update(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DeleteDaiHoiCoDong = createAsyncThunk(
  "daiHoiCoDong/DeleteDaiHoiCoDong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await DaiHoiCoDongService.delete(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const CheckInDaiHoiCoDong = createAsyncThunk(
  "daiHoiCoDong/CheckInDaiHoiCoDong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data || {};
      const response = await DaiHoiCoDongService.checkIn();
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// DanhMucBieuQuyet async thunks
export const SearchDanhMucBieuQuyet = createAsyncThunk(
  "daiHoiCoDong/SearchDanhMucBieuQuyet",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DaiHoiCoDongService.searchDanhMucBieuQuyet(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDanhMucBieuQuyetById = createAsyncThunk(
  "daiHoiCoDong/GetDanhMucBieuQuyetById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DaiHoiCoDongService.getDanhMucBieuQuyetById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const CreateDanhMucBieuQuyet = createAsyncThunk(
  "daiHoiCoDong/CreateDanhMucBieuQuyet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await DaiHoiCoDongService.createDanhMucBieuQuyet(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateDanhMucBieuQuyet = createAsyncThunk(
  "daiHoiCoDong/UpdateDanhMucBieuQuyet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await DaiHoiCoDongService.updateDanhMucBieuQuyet(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DeleteDanhMucBieuQuyet = createAsyncThunk(
  "daiHoiCoDong/DeleteDanhMucBieuQuyet",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await DaiHoiCoDongService.deleteDanhMucBieuQuyet(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetImportCoDongApi = createAsyncThunk(
  "daiHoiCoDong/GetImportCoDongApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, transId } = data;
      const response = await DaiHoiCoDongService.importExcel(transId);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateImportCoDongApi = createAsyncThunk(
  "daiHoiCoDong/UpdateImportCoDongApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await DaiHoiCoDongService.updateImportExcel(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ExportExcelDaiHoiCoDong = createAsyncThunk(
  "daiHoiCoDong/ExportExcelDaiHoiCoDong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ids } = data;
      const response = await DaiHoiCoDongService.exportExcel(ids);
      if (onSuccess) onSuccess(response);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  list: [],
  detail: null,
  checkInInfo: null,
  danhMucBieuQuyetList: [],
  danhMucBieuQuyetDetail: null,
};

export const daiHoiCoDongSlice = createSlice({
  name: "daiHoiCoDong",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    clearDetail: (state) => {
      state.detail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Search
      .addCase(SearchDaiHoiCoDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchDaiHoiCoDong.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchDaiHoiCoDong.rejected, (state) => {
        state.loading = false;
      })
      // GetById
      .addCase(GetDaiHoiCoDongById.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDaiHoiCoDongById.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload;
      })
      .addCase(GetDaiHoiCoDongById.rejected, (state) => {
        state.loading = false;
      })
      // Create
      .addCase(CreateDaiHoiCoDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateDaiHoiCoDong.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(CreateDaiHoiCoDong.rejected, (state) => {
        state.loading = false;
      })
      // Update
      .addCase(UpdateDaiHoiCoDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateDaiHoiCoDong.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(UpdateDaiHoiCoDong.rejected, (state) => {
        state.loading = false;
      })
      // Delete
      .addCase(DeleteDaiHoiCoDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteDaiHoiCoDong.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(DeleteDaiHoiCoDong.rejected, (state) => {
        state.loading = false;
      })
      // CheckIn
      .addCase(CheckInDaiHoiCoDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(CheckInDaiHoiCoDong.fulfilled, (state, action) => {
        state.loading = false;
        state.checkInInfo = action.payload;
      })
      .addCase(CheckInDaiHoiCoDong.rejected, (state) => {
        state.loading = false;
      })
      // DanhMucBieuQuyet Search
      .addCase(SearchDanhMucBieuQuyet.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchDanhMucBieuQuyet.fulfilled, (state, action) => {
        state.loading = false;
        state.danhMucBieuQuyetList = action.payload;
      })
      .addCase(SearchDanhMucBieuQuyet.rejected, (state) => {
        state.loading = false;
      })
      // DanhMucBieuQuyet GetById
      .addCase(GetDanhMucBieuQuyetById.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDanhMucBieuQuyetById.fulfilled, (state, action) => {
        state.loading = false;
        state.danhMucBieuQuyetDetail = action.payload;
      })
      .addCase(GetDanhMucBieuQuyetById.rejected, (state) => {
        state.loading = false;
      })
      // DanhMucBieuQuyet Create
      .addCase(CreateDanhMucBieuQuyet.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateDanhMucBieuQuyet.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(CreateDanhMucBieuQuyet.rejected, (state) => {
        state.loading = false;
      })
      // DanhMucBieuQuyet Update
      .addCase(UpdateDanhMucBieuQuyet.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateDanhMucBieuQuyet.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(UpdateDanhMucBieuQuyet.rejected, (state) => {
        state.loading = false;
      })
      // DanhMucBieuQuyet Delete
      .addCase(DeleteDanhMucBieuQuyet.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteDanhMucBieuQuyet.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(DeleteDanhMucBieuQuyet.rejected, (state) => {
        state.loading = false;
      })
      // Export Excel
      .addCase(ExportExcelDaiHoiCoDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(ExportExcelDaiHoiCoDong.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(ExportExcelDaiHoiCoDong.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading, clearDetail } = daiHoiCoDongSlice.actions;

export default daiHoiCoDongSlice.reducer;
